import { RiVerifiedBadgeFill } from "react-icons/ri";

function ConditionLabel({ text, approved, className = "" }) {
  return (
    <div
      className={`text-cromboOrange bg-amber-100 p-1 flex justify-center items-center rounded-bl-lg text-sm w-12 font-bold ${className}`}>
      {approved && (
        <div className='absolute top-[-8px] right-[-10px] text-green-600 text-xl'>
          <RiVerifiedBadgeFill />
        </div>
      )}
      <div>{text}</div>
    </div>
  );
}

export default ConditionLabel;
